import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// styles
import * as styles from "./TeamCanJoin.module.css";

const propTypes = {
  title: PropTypes.string,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ),
};

const defaultProps = {
  title: "Teams You Can Join at Twin Health",
  teams: [
    {
      title: "Data Science & AI/ML",
      description:
        "Leverage advanced AI and ML technologies to build and enhance the Whole Body Digital Twin™, empowering people to reverse chronic metabolic conditions.",
    },
    {
      title: "Product Development & Engineering",
      description:
        "Design and develop groundbreaking solutions that merge cutting-edge technology with user-friendly experiences to improve health outcomes.",
    },
    {
      title: "Clinical Care Teams",
      description:
        "Work directly with members to deliver personalized care, combining medical expertise and real-time insights to help them achieve lasting health improvements.",
    },
    {
      title: "Sales & Marketing",
      description:
        "Spread the word about Twin Health's life-changing solutions by connecting with individuals, doctors, and businesses who can benefit from our programs.",
    },
    {
      title: "Finance & Operations",
      description:
        "Support our mission by managing resources efficiently and ensuring smooth operations that enable transformative healthcare delivery.",
    },
    {
      title: "Learning & Development",
      description:
        "Empower employees with training, mentorship, and skill-building opportunities to foster personal and professional growth.",
    },
    {
      title: "Human Resources",
      description:
        "Shape and maintain Twin Health's thriving culture by recruiting passionate talent and supporting their well-being and growth throughout their journey.",
    },
    {
      title: "Quality & Compliance",
      description:
        "Ensure the highest standards of quality and adherence to regulations across our processes, ensuring excellence in every aspect of our work.",
    },
  ],
};

const TeamCanJoin = ({ title, teams }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className={styles.teamCanJoinWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Title */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
        </div>

        {/* Teams Grid */}
        <div className="row">
          {teams.map((team, index) => (
            <div key={index} className="col-lg-6 col-12">
              <div className={styles.teamCard}>
                <div className={styles.teamHeader}>
                  <h3 className={styles.teamTitle}>{team.title}</h3>
                </div>
                <p className={styles.teamDescription}>{team.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

TeamCanJoin.propTypes = propTypes;
TeamCanJoin.defaultProps = defaultProps;

export default TeamCanJoin;
